export const SERVICE_CATEGORIES = {
  'Χρώμα': [
    { label: 'Balayage', href: '/balayage-chalandri' },
    { label: 'Hair Color', href: '/services/hair-color' },
    { label: 'Color Correction', href: '/color-correction-athens' },
    { label: 'Babylights', href: '/services/babylights' },
    { label: 'Airtouch', href: '/services/airtouch' },
    { label: 'Hair Glossing', href: '/hair-gloss-athens' },
  ],
  'Κούρεμα': [
    { label: 'Γυναικείο Κούρεμα', href: '/womens-haircut-chalandri' },
    { label: 'Precision Haircut', href: '/precision-haircut-chalandri' },
    { label: 'Κούρεμα για Σγουρά', href: '/kourema-sgoura-mallia-chalandri' },
    { label: 'Κούρεμα Καρέ / Bob', href: '/kourema-kare-chalandri' },
    { label: 'Ανδρικό Κούρεμα', href: '/antriko-kourema-chalandri' },
  ],
  'Θεραπείες': [
    { label: 'Keratin Treatment', href: '/keratin-treatment-chalandri' },
    { label: 'Luxury Hair Treatments', href: '/hair-treatments-athens' },
    { label: 'Hair Botox', href: '/hair-botox-chalandri' },
    { label: 'K18 Treatment', href: '/k18-hair-treatment-chalandri' },
    { label: 'Milbon 360°', href: '/milbon-360-chalandri' },
  ],
  'Consultation': [
    { label: 'Face Metrics Pro', href: '/services/face-metrics-pro' },
    { label: 'Προσωπολογία (Visagisme)', href: '/prosopologia-visagisme' },
    { label: 'Hair Consultation', href: '/hair-consultation-athens' },
    { label: 'Hair Transformation', href: '/hair-transformation-athens' },
    { label: 'Όλες οι Υπηρεσίες →', href: '/services' },
  ],
};